import { render, staticRenderFns } from "./TenantShow.vue?vue&type=template&id=82731446"
import script from "./TenantShow.vue?vue&type=script&lang=ts"
export * from "./TenantShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports